import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

type UnauthorizedHandler = () => void;

let unauthorizedHandler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(handler: UnauthorizedHandler | null) {
  unauthorizedHandler = handler;
}

export function createApiClient(config: AxiosRequestConfig): AxiosInstance {
  const instance = axios.create(config);

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        unauthorizedHandler?.();
      }
      return Promise.reject(error);
    }
  );

  return instance;
}
